import type { LeaveApplyRequest } from "../types";

export type LeaveDraft = LeaveApplyRequest & {
  savedAt: string; // ISO timestamp
};

function key(employeeId: number) {
  return `leave_draft_${employeeId}`;
}

export function saveDraft(employeeId: number, form: LeaveApplyRequest): void {
  const draft: LeaveDraft = { ...form, savedAt: new Date().toISOString() };
  localStorage.setItem(key(employeeId), JSON.stringify(draft));
}

export function loadDraft(employeeId: number): LeaveDraft | null {
  try {
    const raw = localStorage.getItem(key(employeeId));
    return raw ? (JSON.parse(raw) as LeaveDraft) : null;
  } catch {
    return null;
  }
}

export function clearDraft(employeeId: number): void {
  localStorage.removeItem(key(employeeId));
}

export function formatDraftAge(savedAt: string): string {
  const diff = Date.now() - new Date(savedAt).getTime();
  const mins = Math.floor(diff / 60_000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}
